import {Form, Select} from 'antd'
import {SecondaryTherapyDataSchemaElement} from 'src/constants/secondaryTherapyFields'
import {DEVICE_OF_ASSUMPTION_OPTIONS, MODE_OF_ASSUMPTION_OPTIONS, SPEED_UNIT_OPTIONS} from './therapyDialogsConstants'
import {ThreeColumnsGrid} from './TherapyGridStyled'
import UnitSelector from './UnitSelector'

const getContainer = () => document.body

type ModeOfAssumptionFieldsProps = {
  dataSchema: SecondaryTherapyDataSchemaElement[]
}

const ModeOfAssumptionFields: React.FC<ModeOfAssumptionFieldsProps> = ({dataSchema}) => {
  const isFieldVisible = (key: string): boolean => dataSchema.some((element) => element.value === key)
  const fieldLabel = (key: string, fallback: string): string => dataSchema.find((element) => element.value === key)?.name ?? fallback

  return (
    <ThreeColumnsGrid>
      {isFieldVisible('modeOfAssumption') && (
        <Form.Item label={fieldLabel('modeOfAssumption', 'Via di assunzione')} name='modeOfAssumption'>
          <Select
            allowClear
            dropdownStyle={{zIndex: 1400}}
            getPopupContainer={getContainer}
            options={MODE_OF_ASSUMPTION_OPTIONS}
            placeholder='Seleziona una opzione'
          />
        </Form.Item>
      )}
      {isFieldVisible('deviceOfAssumption') && (
        <Form.Item label={fieldLabel('deviceOfAssumption', 'Dispositivo')} name='deviceOfAssumption'>
          <Select
            allowClear
            dropdownStyle={{zIndex: 1400}}
            getPopupContainer={getContainer}
            options={DEVICE_OF_ASSUMPTION_OPTIONS}
            placeholder='Seleziona una opzione'
          />
        </Form.Item>
      )}
      {isFieldVisible('speedOfDevice') && (
        <Form.Item label={fieldLabel('speedOfDevice', 'Velocità device')} name='speedOfDevice'>
          <UnitSelector unitTypeOptions={SPEED_UNIT_OPTIONS} />
        </Form.Item>
      )}
    </ThreeColumnsGrid>
  )
}

export default ModeOfAssumptionFields
